import axios from 'axios';
import EndPointInfo from '../utility/Endpoints';

const { capiGatewayEndpoint } = EndPointInfo;

const updateContactAttributes = async (contactId, attributes) => {
  const response = await axios.post(
    capiGatewayEndpoint,
    { contactId, attributes },
    {
      headers: {
        'X-API-Key': process.env.REACT_APP_API_GATEWAY_API_KEY,
      },
    }
  );
  return response.data;
};

export default updateContactAttributes;
